var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.boxStyle === "full"
    ? _c(
        "div",
        [
          _c(
            "router-link",
            {
              staticClass: "text-reset d-block lh-0 text-center",
              attrs: {
                to: {
                  name: "ProductDetails",
                  params: {
                    slug:
                      _vm.$route.params.slug ||
                      _vm.$store.getters["auth/currentUserShopSlug"],
                    productSlug: _vm.productDetails.slug,
                  },
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "h-300px", staticStyle: { overflow: "hidden" } },
                [
                  _c("img", {
                    staticClass: "border",
                    attrs: {
                      src: _vm.productDetails.thumbnail_image,
                      alt: _vm.productDetails.name,
                    },
                    on: {
                      error: function ($event) {
                        return _vm.imageFallback($event)
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _c(
        "div",
        {
          class: [
            _vm.boxStyle == "two"
              ? "product-box-two"
              : _vm.boxStyle == "three"
              ? "product-box-three"
              : _vm.boxStyle == "four"
              ? "product-box-four"
              : "product-box-one",
          ],
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                [
                  _c("v-skeleton-loader", {
                    attrs: {
                      type: "image",
                      height:
                        _vm.boxStyle == "two"
                          ? "70"
                          : _vm.boxStyle == "three"
                          ? "150"
                          : _vm.boxStyle == "four"
                          ? "130"
                          : "310",
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                {
                  class: [
                    "overflow-hidden",
                    { "rounded border": !_vm.noBorder },
                  ],
                },
                [
                  _c(
                    "v-row",
                    {
                      class: [{ "flex-nowrap": _vm.boxStyle != "one" }],
                      attrs: { align: "center", "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "flex-shrink-0",
                          attrs: {
                            cols: _vm.boxStyle == "one" ? "12" : "auto",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "position-relative" },
                            [
                              _vm.discount > 0 && _vm.boxStyle != "two"
                                ? _c("div", { staticClass: "discount-badge" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("off")) +
                                        " " +
                                        _vm._s(_vm.discount) +
                                        "%"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "pbox-badges" }, [
                                _vm.productDetails.is_hot
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pbox-badge pbox-badge--hot",
                                      },
                                      [_vm._v("HOT")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.productDetails.is_new
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pbox-badge pbox-badge--new",
                                      },
                                      [_vm._v("NEW")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.productDetails.is_event
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pbox-badge pbox-badge--event",
                                      },
                                      [_vm._v("EVENT")]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "text-reset d-block lh-0 text-center",
                                  attrs: {
                                    to: {
                                      name: "ProductDetails",
                                      params: {
                                        slug:
                                          _vm.$route.params.slug ||
                                          _vm.$store.getters[
                                            "auth/currentUserShopSlug"
                                          ],
                                        productSlug: _vm.productDetails.slug,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    class: [
                                      "img-fit",
                                      _vm.boxStyle == "two"
                                        ? "size-70px"
                                        : _vm.boxStyle == "three"
                                        ? "size-150px"
                                        : _vm.boxStyle == "four"
                                        ? "size-130px"
                                        : "h-180px",
                                    ],
                                    attrs: {
                                      src: _vm.productDetails.thumbnail_image,
                                      alt: _vm.productDetails.name,
                                    },
                                    on: {
                                      error: function ($event) {
                                        return _vm.imageFallback($event)
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "minw-0 flex-shrink-0",
                          attrs: { cols: _vm.boxStyle == "one" ? "12" : null },
                        },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "px-3 d-flex flex-column",
                                _vm.boxStyle == "two" ? "py-1" : "py-2",
                              ],
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.$store.getters["auth/isShowPrice"],
                                      expression:
                                        "$store.getters['auth/isShowPrice']",
                                    },
                                  ],
                                },
                                [
                                  _vm.productDetails.base_discounted_price > 0
                                    ? _c(
                                        "div",
                                        {
                                          class: [
                                            _vm.boxStyle == "two"
                                              ? "order-2 fs-14 lh-1"
                                              : "fs-16 mb-2",
                                          ],
                                        },
                                        [
                                          _vm.productDetails.base_price >
                                          _vm.productDetails
                                            .base_discounted_price
                                            ? [
                                                _c(
                                                  "del",
                                                  { staticClass: "opacity-40" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.format_price(
                                                          _vm.productDetails
                                                            .base_price
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "fw-700" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.format_price(
                                                          _vm.productDetails
                                                            .base_discounted_price
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "span",
                                                  { staticClass: "fw-700" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.format_price(
                                                          _vm.productDetails
                                                            .base_discounted_price
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h5",
                                {
                                  class: [
                                    "opacity-80 fw-400 mb-2 lh-1-6",
                                    _vm.boxStyle == "two"
                                      ? "text-truncate fs-12"
                                      : "fs-13",
                                  ],
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "text-reset",
                                      attrs: {
                                        to: {
                                          name: "ProductDetails",
                                          params: {
                                            slug:
                                              _vm.$route.params.slug ||
                                              _vm.$store.getters[
                                                "auth/currentUserShopSlug"
                                              ],
                                            productSlug:
                                              _vm.productDetails.slug,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fs-15 fw-700" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.productDetails.name)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.productDetails.review_summary &&
                              _vm.generalSettings.reviews == 1
                                ? _c(
                                    "div",
                                    { staticClass: "review-info mt-1 mb-2" },
                                    [
                                      _c("v-rating", {
                                        attrs: {
                                          "background-color": "",
                                          "empty-icon": "las la-star",
                                          "full-icon": "las la-star active",
                                          "half-icon": "las la-star half",
                                          hover: "",
                                          "half-increments": "",
                                          readonly: "",
                                          size: "14",
                                          length: "5",
                                          value:
                                            _vm.productDetails.review_summary
                                              .average,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "review-text ms-1" },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                (
                                                  _vm.productDetails
                                                    .review_summary.average || 0
                                                ).toFixed(1)
                                              ) +
                                              "\n                            (" +
                                              _vm._s(
                                                _vm.productDetails
                                                  .review_summary.total_count
                                              ) +
                                              ")\n                        "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.boxStyle != "two" &&
                              _vm.productDetails.product_section != "printing"
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            _vm.boxStyle == "three" ||
                                            _vm.boxStyle == "four"
                                              ? "me-3"
                                              : "flex-grow-1 me-1",
                                          ],
                                        },
                                        [
                                          _vm.productDetails.stock
                                            ? [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "text-reset py-1 lh-1 align-center d-flex",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showAddToCartDialog(
                                                          {
                                                            status: true,
                                                            slug: _vm
                                                              .productDetails
                                                              .slug,
                                                          }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "la la-shopping-cart fs-20 ts-05 me-1",
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "fw-700 fs-13",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("buy_now")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "fw-700 fs-13 opacity-60",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("out_of_stock")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _vm.isThisWishlisted(
                                            _vm.productDetails.id
                                          )
                                            ? [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "primary--text pa-1 lh-1",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeFromWishlist(
                                                          _vm.productDetails.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "la la-heart ts-02 fs-18",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "primary--text pa-1 lh-1",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addNewWishlist(
                                                          _vm.productDetails.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "la la-heart-o ts-02 fs-18",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }